/**
 * BMM — Linen Edit / Editorial Split
 * Version: 2.0 — Exact mockup match
 * 3-state carousel: prev (scale.8) / active (scale 1) / next (scale.9)
 * Auto-advance 4000ms, pause on hover, touch swipe
 */
(function () {
  'use strict';

  function init(section) {
    var sid   = section.dataset.sectionId;
    var clip  = document.getElementById('bmmLeClip-' + sid);
    var btnP  = document.getElementById('bmmLePrev-' + sid);
    var btnN  = document.getElementById('bmmLeNext-' + sid);

    if (!clip) return;

    var slides = Array.from(clip.querySelectorAll('.bmm-le__slide'));
    var N      = slides.length;
    var cur    = 0;
    var locked = false;
    var timer  = null;

    if (N === 0) return;

    /* ── RENDER 3 STATES ── */
    function render() {
      var prevIdx = (cur - 1 + N) % N;
      var nextIdx = (cur + 1) % N;

      slides.forEach(function (s, i) {
        s.classList.remove(
          'bmm-le__slide--active',
          'bmm-le__slide--prev',
          'bmm-le__slide--next'
        );
        if      (i === cur)      s.classList.add('bmm-le__slide--active');
        else if (i === nextIdx)  s.classList.add('bmm-le__slide--next');
        else if (i === prevIdx)  s.classList.add('bmm-le__slide--prev');
        /* All others: no class = opacity:0, hidden */
      });
    }

    /* ── GO TO SLIDE ── */
    function go(n) {
      if (locked) return;
      locked = true;
      cur = ((n % N) + N) % N;
      render();
      setTimeout(function () { locked = false; }, 660);
    }

    function next() { go(cur + 1); }
    function prev() { go(cur - 1); }

    /* ── INIT ── */
    render();

    /* ── ARROWS ── */
    if (btnN) btnN.addEventListener('click', function () { next(); stopTimer(); startTimer(); });
    if (btnP) btnP.addEventListener('click', function () { prev(); stopTimer(); startTimer(); });

    /* ── AUTO ADVANCE ── */
    function startTimer() {
      if (timer) clearInterval(timer);
      timer = setInterval(next, 4000);
    }

    function stopTimer() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    startTimer();

    /* Pause on hover */
    var left = section.querySelector('.bmm-le__left');
    if (left) {
      left.addEventListener('mouseenter', stopTimer, { passive: true });
      left.addEventListener('mouseleave', startTimer, { passive: true });
    }

    /* ── TOUCH SWIPE ── */
    var tx = 0, tActive = false, tDone = false;
    clip.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      tx = e.touches[0].clientX;
      tActive = true;
      tDone = false;
    }, { passive: true });

    clip.addEventListener('touchmove', function (e) {
      if (!tActive || tDone || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - tx;
      if (Math.abs(dx) > 44) {
        tDone = true;
        tActive = false;
        stopTimer();
        dx < 0 ? next() : prev();
        startTimer();
      }
    }, { passive: true });

    clip.addEventListener('touchend', function () {
      tActive = false;
      tDone = false;
    });

    /* ── INTERSECTION OBSERVER — pause when off-screen ── */
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) stopTimer();
          else startTimer();
        });
      }, { threshold: 0.1 });
      obs.observe(section);
    }

    /* ── THEME EDITOR RE-INIT CLEANUP ── */
    if (section._bmmLeTimer) clearInterval(section._bmmLeTimer);
    section._bmmLeTimer = timer;
  }

  function initAll() {
    document.querySelectorAll('.bmm-le[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.bmm-le[data-section-id]');
    if (s) init(s);
  });

})();
